import React, { Fragment, useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { incNumberOfOrders } from "@redux"
import { useDispatch } from "react-redux"
import clsx from "clsx"

import OhCanceledModal from "./OhCanceledModal"
import { getOrder } from "services"
import { haveAuth } from "utils"
import { SidebarModal } from "components"
import OhFooter from "./OhFooter"
import OhStatus from "./OhStatus"
import OhAddress from "./OhAddress"
import OhCustomerInfo from "./OhCustomerInfo"
import OhGroupedOrderCard from "./OhGroupedOrderCard"
import OhDeliveredButton from "./OhDeliveredButton"
import OhCanceledButton from "./OhCanceledButton"
import OhOrderNote from "./OhOrderNote"
import OhPaymentDetails from "./OhPaymentDetails"
import OhHeader from "./OhHeader"
import OhCoupons from "./OhCoupons"
import classes from "./index.module.scss"

const OhOrderDetailsModal = props => {
  const {
    readOnly,
    order,
    setOrders,
    openDetailsModal,
    setOpenDetailsModal
  } = props

  const [t] = useTranslation()

  const dispatch = useDispatch()

  const [showCancelModal, setShowCancelModal] = useState(false)
  const [disabledButton, setDisableButton] = useState("")

  const unmount = useRef(false)

  const handleIsOrderViewed = async () => {
    if (order.isViewed) return

    await getOrder(order._id)

    setOrders(prev =>
      prev.map(o =>
        o._id === order._id
          ? { ...o, isViewed: true }
          : o
      )
    )

    dispatch(
      incNumberOfOrders(
        order.orderStatus,
        -1
      ))
  }

  useEffect(() => {
    unmount.current = false

    return () => { unmount.current = true }
  }, [])

  const showCancelOrderButton =
    !readOnly &&
    haveAuth(["cancelOrder"]) &&
    (
      order.orderStatus === "paid" ||
      order.orderStatus === "pending" ||
      order.orderStatus === "notConfirmed"
    )

  const showDeliveredButton =
    !readOnly &&
    haveAuth(["completeOrder"]) &&
    order.orderStatus === "paid"

  const removeHeight =
    showDeliveredButton ||
    showCancelOrderButton

  return (
    <Fragment>
      <SidebarModal
        urlQuery="code"
        urlQueryValue={order.code}
        open={openDetailsModal}
        onEnter={handleIsOrderViewed}
        onClose={() => setOpenDetailsModal(false)}
        title={`${t("سفارش_orderCode", { orderCode: order.code })}${
          order.dailyOrderNumber !== undefined
            ? ` - ${t("شماره_روزانه")} ${String(order.dailyOrderNumber).padStart(3, "0")}`
            : ""
        }`}
      >
        <div
          className={clsx(
            classes["container"],
            removeHeight && classes["full-height"]
          )}
        >
          <OhStatus
            order={order}
            readOnly={readOnly}
            setOrders={setOrders}
          />

          {
            order.deliveryType === "delivery" &&
            <OhAddress
              order={order}
              setOrders={setOrders}
            />
          }

          <OhHeader
            order={order}
          />

          <OhCustomerInfo
            order={order}
          />

          <OhOrderNote
            order={order}
          />

          <OhPaymentDetails
            order={order}
          />

          <OhCoupons
            order={order}
          />

          <div className={classes["grouped-orders"]}>
            <OhGroupedOrderCard order={order} />
          </div>

          <OhFooter
            order={order}
          />

        </div>
        <div className={classes["row"]}>
          {
            showDeliveredButton &&
            <OhDeliveredButton
              order={order}
              setOrders={setOrders}
              disabledButton={disabledButton}
              setDisableButton={setDisableButton}
            />
          }
          {
            showCancelOrderButton &&
            <OhCanceledButton
              setShowCancelModal={setShowCancelModal}
            />
          }
        </div>
      </SidebarModal>

      <OhCanceledModal
        order={order}
        setOrders={setOrders}
        setDisableButton={setDisableButton}
        showCancelModal={showCancelModal}
        setShowCancelModal={setShowCancelModal}
      />
    </Fragment>
  )
}

export default OhOrderDetailsModal
